import React from "react";

/**
 * SampleCard — a generic, illustrative example card for the logged-out pages
 * (e.g. "what a reward / mission / store item looks like"). Deliberately NON
 * personal: no real balances, no "your current" highlight, no claim/redeem
 * action. It only shows what the feature looks like to entice sign-up.
 *
 * If no `image` is provided a branded gradient placeholder renders instead, so
 * this component never depends on a missing asset.
 *
 * Props:
 *   image?     str    src of an EXISTING asset (optional)
 *   imageAlt?  str
 *   badge?     node   small corner tag (e.g. "Sample")
 *   title      node
 *   subtitle?  node
 *   footer?    node   e.g. a non-interactive value line
 *   locked?    bool   show a subtle lock affordance (default false)
 *   className? str
 */
const SampleCard = ({
  image,
  imageAlt = "",
  badge,
  title,
  subtitle,
  footer,
  locked = false,
  className = "",
}) => {
  return (
    <div
      className={
        "teaser-sample" +
        (locked ? " teaser-sample--locked" : "") +
        (className ? ` ${className}` : "")
      }
    >
      <div className="teaser-sample__media">
        {image ? (
          <img src={image} alt={imageAlt} loading="lazy" />
        ) : (
          <div className="teaser-sample__placeholder" aria-hidden="true" />
        )}
        {badge ? <span className="teaser-sample__badge">{badge}</span> : null}
        {locked ? (
          <span className="teaser-sample__lock" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </span>
        ) : null}
      </div>
      <div className="teaser-sample__body">
        {title ? <div className="teaser-sample__title">{title}</div> : null}
        {subtitle ? (
          <div className="teaser-sample__sub">{subtitle}</div>
        ) : null}
        {footer ? <div className="teaser-sample__footer">{footer}</div> : null}
      </div>
    </div>
  );
};

export default SampleCard;
